<template>
  <div>
    <template v-if="!$vuetify.breakpoint.mobile">
      <div class="ma-5">
        <v-row>
          <v-col cols="auto" md="7" lg="8" style="display: flex">
            <v-row dense class="ma-0">
              <!-- ОПИСАНИЕ -->
              <div class="pa-5" style="border: thin solid rgba(0, 0, 0, 0.12)">
                <h3>
                  {{ description.brief }}
                </h3>
                <v-divider class="my-2"></v-divider>
                <div>{{ description.full }}</div>
              </div>

              <!-- КОМПОНЕНТЫ -->
              <div style="margin-top: auto">
                <h3 class="ml-5 ma-3">Компоненты комплекса Баласка</h3>
                <v-expansion-panels focusable flat>
                  <v-expansion-panel
                    v-for="c in components"
                    :key="c.id"
                    style="border: thin solid rgba(0, 0, 0, 0.12)"
                  >
                    <v-expansion-panel-header>
                      {{ c.brief }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <component :is="c.full"></component>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-row>
          </v-col>

          <!-- ВОЗМОЖНОСТИ -->
          <v-col style="display: flex">
            <div class="pa-5" style="border: thin solid rgba(0, 0, 0, 0.12)">
              <h3>Возможности</h3>
              <v-divider class="my-2"></v-divider>
              <v-list dense>
                <v-list-item
                  v-for="f in features"
                  :key="f.id"
                  :to="f.to"
                  :style="{
                    border: f.to ? 'thin solid rgba(0,0,0,0.12)' : '',
                  }"
                >
                  <v-list-item-icon>
                    <v-icon :color="f.color">{{ f.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-wrap"
                      style="font-size: 16px"
                    >
                      {{ f.text }}
                      <div v-if="f.component">
                        <component :is="f.component"></component>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                  <!-- <v-list-item-action v-if="f.to">
                    <v-icon>mdi-variant</v-icon>
                  </v-list-item-action> -->
                </v-list-item>
              </v-list>
            </div>
          </v-col>
        </v-row>

        <!-- КОМПОНЕНТЫ -->
        <!-- <v-row>
          <v-col cols="auto" md="7" lg="8" style="display: flex">
            <div>
              <h3 class="ml-5 mb-3">Компоненты комплекса Баласка</h3>
              <v-expansion-panels focusable flat>
                <v-expansion-panel
                  v-for="c in components"
                  :key="c.id"
                  style="border: thin solid rgba(0, 0, 0, 0.12)"
                >
                  <v-expansion-panel-header>
                    {{ c.brief }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{ c.full }}
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-col>
        </v-row> -->
      </div>
    </template>
    <template v-else>
      <h3 class="py-3" style="text-align: center">Описание</h3>

      <div class="pa-2">
        <v-expansion-panels focusable flat>
          <v-expansion-panel style="border: thin solid rgba(0, 0, 0, 0.12)">
            <v-expansion-panel-header>
              {{ description.brief }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              {{ description.full }}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <h3 class="py-3" style="text-align: center">Возможности</h3>

        <v-list dense>
          <v-list-item
            v-for="f in features"
            :key="f.id"
            :to="f.to"
            :style="{
              border: f.to ? 'thin solid rgba(0,0,0,0.12)' : '',
            }"
          >
            <v-list-item-icon>
              <v-icon :color="f.color">{{ f.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap" style="font-size: 16px">
                {{ f.text }}
                <div v-if="f.component">
                  <component :is="f.component"></component>
                </div>
              </v-list-item-title>
            </v-list-item-content>
            <!-- <v-list-item-action>
              <v-icon v-if="f.to">mdi-link-variant</v-icon>
            </v-list-item-action> -->
          </v-list-item>
        </v-list>

        <h3 class="py-3" style="text-align: center">
          Компоненты комплекса Баласка
        </h3>

        <v-expansion-panels focusable flat>
          <v-expansion-panel
            v-for="c in components"
            :key="c.id"
            style="border: thin solid rgba(0, 0, 0, 0.12)"
          >
            <v-expansion-panel-header>
              {{ c.brief }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <component :is="c.full"></component>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </template>
  </div>
</template>

<script setup>
import { h, defineComponent, ref, computed, getCurrentInstance } from "vue";

// import { VBtn, VIcon, VTooltip, VImg } from "vuetify/lib";

// import { previewFile } from "@/components/FormContent/methods.tsx";

import { features, description, components } from "./HomeData.jsx";

const app = getCurrentInstance();
const $vuetify = app.proxy.$vuetify;

// const maxWidth = computed(() => {
//   return { maxWidth: $vuetify.breakpoint.smAndDown ? "100%" : "60vw" };
// });

// const Analytics = defineComponent({
//   render() {
//     return h("img", { attrs: { src: "/img/analytics.jpeg", width: "100%" } });
//   },
// });

// const Waybills = defineComponent({
//   render() {
//     return h("img", { attrs: { src: "/img/waybills.png", width: "100%" } });
//   },
// });

// const PreviewPhoto = defineComponent({
//   methods: {
//     btn(color, hint, image) {
//       return h(
//         VTooltip,
//         {
//           attrs: { bottom: "" },
//           scopedSlots: {
//             activator: function ({ on }) {
//               return [
//                 h(
//                   VBtn,
//                   {
//                     props: { color, outlined: true, small: true },
//                     class: "pa-2",
//                     style: { minWidth: 0, borderColor: "rgba(0,0,0,0.12)" },
//                     on: {
//                       click: () => previewFile(0, "image", image),
//                       ...on,
//                     },
//                   },
//                   [h(VIcon, { props: { small: true } }, ["mdi-camera"])]
//                   // [h(VImg,{ props: { src: image, width: "16", height: "16" } }, ["mdi-camera"])]
//                 ),
//               ];
//             },
//           },
//         },
//         [h("span", [hint])]
//       );
//     },
//   },
//   render() {
//     return h("div", [
//       this.btn("blue", "До погрузки", "/img/container_before.jpg"),
//       h("span", { class: "mx-1" }),
//       this.btn("green", "После погрузки", "/img/container_after.jpg"),
//     ]);
//   },
// });

// const features = ref([
//   {
//     icon: "mdi-poll",
//     color: "orange",
//     text: "Организация, учет и детальная аналитика погрузочных работ",
//     component: Analytics,
//   },
//   {
//     icon: "mdi-camera",
//     color: "blue",
//     text: "Фотографирование мусорных объектов до и после погрузки",
//     component: PreviewPhoto,
//   },
//   {
//     icon: "mdi-map-marker",
//     color: "red",
//     text: "Получение географических координат всех мусорных объектов",
//   },
//   {
//     icon: "mdi-map-marker-path",
//     color: "red",
//     text: "Автоматическое формирование путевых листов",
//     // component: Waybills,
//   },
//   {
//     icon: "mdi-map-check-outline",
//     color: "green",
//     text: "Он-лайн отображение мусорных объектов и их статусов на карте",
//     to: "/map",
//   },
// ]);

// const description = ref({
//   brief: `Баласка - программный комплекс, предназначенный для автоматизации
//           работы компаний, оказывающих услуги по вывозу мусора - строительного,
//           производственного, бытового. Комплекс обеспечивает взаимодействие персонала
//           (диспетчеры, водители мусоровозов) внутри компании, а также между компанией
//           и потребителями услуг.`,
//   full: `Комплекс Баласка разработан и используется компаниями в технологии
//           SaaS (программное обеспечение как услуга). Это значит, что компании не
//           нужны дорогостоящие сервера с технической поддержкой, забота о
//           сохранности информации, установка и обновление программ, специалисты
//           (программисты, системщики, операторы) для работы с комплексом. Все это
//           берем на себя мы. Подключение за символическую плату, и обеспечена
//           возможность работы диспетчеров и водителей 24 часа в сутки, 7 дней в
//           неделю. Диспетчер может работать в Баласке с обычным, самым дешёвым
//           ноутбуком, подключенным к интернет, в любом месте - в офисе, дома, на
//           даче. Водитель может использовать приложение Баласка на любом
//           смартфоне под Android в городе, селе, поле, горах. Заказчик может
//           заказать вывоз мусора в приложении Баласка фактически одним нажатием
//           кнопки «фото» в пределах географического ареала действия компании,
//           вывозящей мусор.`,
// });

// const components = ref([
//   {
//     brief: `Cайт, предназначенный для работы диспетчеров и управляющего персонала
//             компании вывозящей мусор`,
//     full: `
//     Позволяет удаленно управлять базами данных компании - видами мусора,
//             типами и наличием контейнеров, автомобилями и спецтехникой, видами
//             услуг, персоналом. Через сайт ведется учёт договоров, заказов,
//             заявок потребителей услуг компании, составляются расписания и
//             графики вывоза мусора. Диспетчеры могут формировать и корректировать
//             путевые листы водителям мусоровозов (в том числе автоматически),
//             общаться по собственной безопасной связи непосредственно с сайта с
//             водителями и заказчиками посредством чатов и/или голоса. На сайте
//             доступны различные формы отчетности и статистики для диспетчеров и
//             управляющего персонала компании. Инфографика комплекса отображает на
//             Яндекс-картах запланированные на этот день и отработанные водителями
//             мусорные объекты в реальном режиме времени.`,
//   },
//   {
//     brief: `Приложение Баласка для смартфонов на базе Android для водителей
//             мусоровозов`,
//     full: `Приложение спроектировано максимально просто и удобно для водителей,
//             все функции интуитивно понятны, для его применения никакой специальной подготовки
//             водителя не требуется. Приложение получает путевой
//             лист на текущую дату, выстраивает список мусорных объектов для
//             отработки по приоритетам, установленным диспетчером. Каждый объект
//             (мусорный контейнер, площадка, свалка) в путевом листе имеет адрес и
//             точные географические координаты. При желании водитель может
//             двигаться к каждому объекту с помощью одного из наиболее популярных
//             в РФ навигаторов, автоматически вызываемых из приложения. Водитель
//             отмечает в приложении время выезда на каждый объект, по прибытии на
//             объект фотографирует его с мусором, после погрузки фотографирует
//             чистую площадку. Координаты, фото и время всех действий
//             автоматически передаются на сервер и моментально доступны диспетчеру
//             и заказчику. При невозможности осуществить погрузку мусора водитель
//             снимает короткое видео с описанием причины, не позволившей погрузить
//             мусор. В приложении также учитываются все выезды на мусорные
//             полигоны в течение смены. Вход в приложение и его использование возможны
//             после выдачи водителю диспетчером уникального
//             логина/пароля. Водителю в любой момент доступен текстовый чат с
//             диспетчером, а также возможность бесплатной голосовой связи с ним с
//             использованием технологии РУССКИЙ ТЕЛЕФОН. В случае отсутствия
//             интернет или неустойчивой связи во время движения мусоровоза, вся
//             описанная технология отработки объектов сохраняется, данные
//             автоматически передаются на сервер при восстановлении связи.`,
//   },
//   {
//     brief: `Приложение Баласка для заказчиков вывоза мусора`,
//     full: `Приложение Баласка для заказчиков вывоза мусора доступно для
//             смартфонов на базе Android и смартфонов iPhone. Для регистрации
//             заказчика в Баласке требуется только номер телефона и E-mail
//             заказчика. Оформление заказа на вывоз мусора реализовано
//             максимально просто и удобно: одной кнопкой делается
//             фотографирование мусорного объекта, определение точных
//             географических координат, передача заказа диспетчеру.
//             Дополнительно можно указать желательное время приезда
//             мусоровоза, количество грузчиков. Автоматически по координатам
//             выбирается компания по вывозу мусора, работающая в этом
//             географическом ареале. Диспетчер выбранной компании по
//             фотографии, координатам определяет вид транспорта, возможность
//             его подачи в нужное время к объекту, рассчитывает цену по
//             прейскуранту, присылает на смартфон заказчика счет на оплату.
//             Заказчик оплачивает вывоз из приложения сразу банковской картой
//             или оплачивает счет в банке, а диспетчеру в приложении присылает
//             копию чека или платежного поручения. Для согласования
//             дополнительных условий и нюансов в приложении Баласка реализован
//             чат с диспетчером и водителем. Выезд водителя на объект, фото
//             мусора по приезду, фотография окончания погрузки приложение
//             заказчика получает мгновенными сообщениями с дублированием на
//             электронную почту.`,
//   },
// ]);
</script>

<style scoped>
h3 {
  color: #22b14c;
  font-weight: normal;
}

ul {
  list-style-type: "- ";
}

li {
  padding-bottom: 5px;
}
</style>
